/* eslint-disable import/prefer-default-export */
export const mapChangePasswordToApi = (data) => ({
  current_password: data.oldPassword,
  new_password: data.newPassword,
  confirm_password: data.newConfirmPassword,
});
